//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { CampaignsStateFactory } from '@campaigns/routes/stateFactory';

import {
  componentNameToTemplate,
  hasFeature,
} from 'app/initialization/routing/stateHelpers';

export const ambassadorStates = {
  'campaigns.ambassadors-community': CampaignsStateFactory({
    data: {
      hasAccess: () => hasFeature(FeatureNames.VibeAmbassadors),
      title: 'Campaigns: Ambassadors Community',
    },
    url: '/ambassadors/community',
    views: {
      main: {
        template: componentNameToTemplate('ambassadorsCommunityPage'),
      },
    },
  }),
};
